import { X } from "@phosphor-icons/react";
import clsx from "clsx";

type FilterChipProps = {
    children: React.ReactNode;
    onRemove?: () => void;
};

const FilterChip = ({ children, onRemove }: FilterChipProps) => {
    return (
        <div
            className={clsx(
                "rounded-full h-9 px-5 flex items-center bg-soft-green-80",
                onRemove && "pr-3"
            )}
        >
            {children}
            {onRemove && (
                <button
                    className="ml-2 rounded-full transition-colors hover:bg-black/10 p-1"
                    onClick={onRemove}
                >
                    <X weight="bold" size={14} />
                </button>
            )}
        </div>
    );
};

export default FilterChip;
